<template>
	<div class="space-y-3" data-popup-form>

		<!-- Enable/Disable Toggle -->
		<EnableDisableToggle 
			v-model="modelValue.enabled"
			@update:modelValue="$emit('update:enabled', $event)"
		/>

		<!-- Publish Scheduler -->
		<PublishScheduler 
			:modelValue="publishSchedulerData"
			:show-helper-text="true"
			@update:modelValue="handlePublishSchedulerUpdate"
		/>

		<!-- Section Type -->
		<SectionTypeFilter 
			v-model="modelValue.sectionType" 
			@update:modelValue="$emit('update:sectionType', $event)"
		/>

		<!-- Stage -->
		<StageFilter 
			v-model="modelValue.stageId" 
			:available-stages="availableStages"
			@update:modelValue="$emit('update:stageId', $event)"
		/>

		<!-- Status -->
		<StatusFilter 
			v-model="modelValue.status"
			@update:modelValue="$emit('update:status', $event)"
		/>

		<!-- Section Size -->
		<div class="space-y-1">
			<label for="sectionSize" class="block text-sm font-medium text-gray-700">Section Size</label>
			<input 
				:value="modelValue.sectionSize || ''"
				@input="$emit('update:sectionSize', $event.target.value)"
				type="text" 
				id="sectionSize" 
				class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent text-sm bg-white" 
				placeholder="Enter section size"
			/>
		</div>

		<!-- Price -->
		<div class="space-y-1">
			<label for="price" class="block text-sm font-medium text-gray-700">Price</label>
			<input 
				:value="modelValue.price || ''"
				@input="handlePriceInput"
				type="text" 
				id="price" 
				class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent text-sm bg-white" 
				placeholder="Enter price"
			/>
		</div>
	</div>
</template>

<script>
import EnableDisableToggle from './edit/EnableDisableToggle.vue'
import PublishScheduler from './edit/PublishScheduler.vue'
import SectionTypeFilter from './edit/SectionTypeFilter.vue'
import StageFilter from './edit/StageFilter.vue'
import StatusFilter from './edit/StatusFilter.vue'

export default {
	name: 'LotEntryForm',
	components: {
		EnableDisableToggle,
		PublishScheduler,
		SectionTypeFilter,
		StageFilter,
		StatusFilter
	},
	props: {
		availableStages: {
			type: Array,
			default: () => []
		},
		modelValue: {
			type: Object,
			default: () => ({
				stageId: '',
				status: '',
				sectionSize: '',
				price: '',
				sectionType: '',
				enabled: true,
				postDate: ''
			})
		},
		isEditing: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue', 'update:stageId', 'update:status', 'update:sectionSize', 'update:price', 'update:sectionType', 'update:enabled', 'update:postDate'],
	data() {
		return {
			localPublishOption: 'now' // Default to 'now' instead of deriving from postDate
		}
	},
	computed: {
		publishSchedulerData() {
			// Return the local state, not derived from postDate
			return {
				publishOption: this.localPublishOption,
				postDate: this.modelValue.postDate || ''
			}
		}
	},
	watch: {
		// Watch for changes from parent (when editing existing entry)
		'modelValue.postDate': {
			immediate: true,
			handler(newPostDate) {
				// Only set to schedule if there's a future date when component loads
				if (newPostDate && !this.localPublishOption) {
					this.localPublishOption = 'schedule'
				}
			}
		}
	},
	methods: {
		handlePriceInput(event) {
			const value = event.target.value
			if (value === '' || /^\d*\.?\d*$/.test(value)) {
				this.$emit('update:price', value)
			} else {
				event.target.value = this.modelValue.price || ''
			}
		},
		handlePublishSchedulerUpdate(value) {
			// Update local state
			this.localPublishOption = value.publishOption
			
			// Convert publishScheduler format back to postDate
			if (value.publishOption === 'schedule' && value.postDate) {
				this.$emit('update:postDate', value.postDate)
			} else if (value.publishOption === 'now') {
				// Set to today at midnight
				const today = new Date()
				today.setHours(0, 0, 0, 0)
				this.$emit('update:postDate', today.toISOString())
			} else {
				this.$emit('update:postDate', '')
			}
		}
	}
}
</script>